export default "/images/8c490feb9cdeb8d2f5e85ccd4c448bc7.avif";